import persist from './persist'

export default {
  setLoading (state, status) {
    state.tractsLoading = status
  },
  setTracts (state, tracts) {
    state.tracts = tracts
  },
  setTractGroupsLoading (state, status) {
    state.tractGroupsLoading = status
  },
  setTractGroups (state, tractGroups) {
    state.tractGroups = tractGroups
  },
  addTract (state, tract) {
    state.tracts.push(tract)
  },
  removeTract (state, tractId) {
    state.tracts = state.tracts.filter(t => t.tractId !== tractId)
  },
  removeTractGroup (state, tractGroupId) {
    state.tractGroups = state.tractGroups.filter(tg => tg.tractGroupId !== tractGroupId)
  },
  updateTract (state, tract) {
    const index = state.tracts.findIndex(t => t.tractId === tract.tractId)
    if (index !== -1) {
      Object.assign(state.tracts[index], tract)
    }
  },
  updateTractGroup (state, tractGroup) {
    const index = state.tractGroups.findIndex(tg => tg.tractGroupId === tractGroup.tractGroupId)
    if (index !== -1) {
      Object.assign(state.tractGroups[index], tractGroup)
    }
  },
  setChosenTract (state, tract) {
    state.chosenTract = tract
  },
  setTransitionMode (state, mode) {
    state.transitionMode = mode
  },
  setTractTimberVolume (state, timberVolume) {
    state.tractTimberVolume = timberVolume
  },
  setStandingTimberFilter (state, filter) {
    state.standingTimberFilter = filter
    persist.standingTimberFilter.write(filter)
  },
  setCommittedTimberFilter (state, filter) {
    state.committedTimberFilter = filter
    persist.committedTimberFilter.write(filter)
  },
  setTimberPortfolioFilter (state, filter) {
    state.timberPortfolioFilter = filter
    persist.timberPortfolioFilter.write(filter)
  },
  setConversions (state, conversions) {
    state.conversions = conversions
  },
  addConversion (state, conversion) {
    state.conversions.push(conversion)
  },
  removeConversion (state, conversionId) {
    state.conversions = state.conversions.filter(c => c.conversionId !== conversionId)
  },
  updateConversion (state, conversion) {
    const index = state.conversions.findIndex(c => c.conversionId === conversion.conversionId)
    if (index !== -1) {
      Object.assign(state.conversions[index], conversion)
    }
  },
  setLandownerTypes (state, landownerTypes) {
    state.landownerTypes = landownerTypes
  },
  addLandownerType (state, landownerType) {
    state.landownerTypes.push(landownerType)
  },
  removeLandownerType (state, landownerTypeId) {
    state.landownerTypes = state.landownerTypes.filter(lt => lt.landownerTypeId !== landownerTypeId)
  },
  updateLandownerType (state, landownerType) {
    const index = state.landownerTypes.findIndex(lt => lt.landownerTypeId === landownerType.landownerTypeId)
    if (index !== -1) {
      Object.assign(state.landownerTypes[index], landownerType)
    }
  },
  setBidCostTypes (state, bidCostTypes) {
    state.bidCostTypes = bidCostTypes
  },
  addBidCostType (state, bidCostType) {
    state.bidCostTypes.push(bidCostType)
  },
  removeBidCostType (state, bidCostTypeId) {
    state.bidCostTypes = state.bidCostTypes.filter(bct => bct.bidCostTypeId !== bidCostTypeId)
  },
  updateBidCostType (state, bidCostType) {
    const index = state.bidCostTypes.findIndex(bct => bct.bidCostTypeId === bidCostType.bidCostTypeId)
    if (index !== -1) {
      Object.assign(state.bidCostTypes[index], bidCostType)
    }
  },
  setTimberCategories (state, timberCategories) {
    state.timberCategories = timberCategories
  },
  addTimberCategory (state, timberCategory) {
    state.timberCategories.push(timberCategory)
  },
  removeTimberCategory (state, timberCategoryId) {
    state.timberCategories = state.timberCategories.filter(tc => tc.timberCategoryId !== timberCategoryId)
  },
  updateTimberCategory (state, timberCategory) {
    const index = state.timberCategories.findIndex(tc => tc.timberCategoryId === timberCategory.timberCategoryId)
    if (index !== -1) {
      Object.assign(state.timberCategories[index], timberCategory)
    }
  }
}
